import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    const url = event.params.url
    if (url) window.open(url, "_blank")
  }
}
